export default __webpack_public_path__ + "static/media/Jawsnapper's Hide.90ed4b36.jpg";